import React, {CSSProperties} from "react";
import {observer} from "mobx-react";
import {
    IJourneyShoppingCartViewModel
} from "../../../services/booking/models/shopping-cart/journey/journey-shopping-cart-view-model.interface";
import {useServices} from "../../../hooks/use-services.hook";
import {StationCodeBox} from "../common/ticket-station.component";
import {PlaneHorizontalFilledIcon} from "../../../assets/svg/plane-horizontal-filled.icon";

interface TicketJourneyGrandTotalComponentProps {
    journeyCart: IJourneyShoppingCartViewModel;
}
export const TicketJourneyGrandTotalComponent: React.FC<TicketJourneyGrandTotalComponentProps> = observer((props) => {
    const services = useServices();
    const theme = services.theme.currentTheme;
    const rootStyles: CSSProperties = {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: theme.fontSize.h2,
        fontWeight: theme.fontWeight.bold,
        paddingLeft: theme.spacing.cardDefaultPadding,
        paddingRight: theme.spacing.cardDefaultPadding,
        pageBreakInside: "avoid",
        breakInside: "avoid"
    }

    const leftSideStyle: CSSProperties = {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: theme.spacing.flexGap8
    }

    return (
        <div style={rootStyles}>
            <div style={leftSideStyle}>
                <span>{services.language.translate('Total')}</span>
                <StationCodeBox stationCode={props.journeyCart.designator.origin.stationCode}/>
                <PlaneHorizontalFilledIcon size={1.4}/>
                <StationCodeBox stationCode={props.journeyCart.designator.destination.stationCode}/>
            </div>

            <span>{props.journeyCart.grandTotalToDisplay.toString()}</span>
        </div>
    );
})